import { Navigate, useNavigate, useOutletContext } from 'react-router-dom';
import AccionaButton from '../../../../../components/AccionaButton';
import styles from './index.module.scss';
import { useIntl } from 'react-intl';
import AccionaTable from '../../../../../components/AccionaTable';
import { COLUMNS_HEADERS } from './columns';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import * as actions from '../../../../../services/redux/cemexTracking/actions';
import VolumeStatus from '../../../../../components/VolumeStatus';
import PropTypes from '../../../../../utils/propTypes';
import { Tag } from 'antd';
import AntdDatePicker from '../../../../../components/AntdDatePicker';
import { useState } from 'react';
import { Providers } from '../../../../../constants/providers';

const { actionsWrapper, expanded } = styles;

const STATUS_DICTIONARY = {
  WCL: { code: 'WCL', color: '#999999' },
  NTK: { code: 'NTK', color: '#999999' },
  ORT: { code: 'ORT', color: '#0370C3' },
  STR: { code: 'STR', color: '#0370C3' },
  FIN: { code: 'FIN', color: '#008000' },
  CNL: { code: 'CNL', color: '#0370C3' },
  BTG: { code: 'BTG', color: '#0370C3' },
  CAN: { code: 'CAN', color: '#FF0000' },
  OST: { code: 'OST', color: '#0370C3' },
  POU: { code: 'POU', color: '#0370C3' },
  CMP: { code: 'CMP', color: '#008000' },
  OHD: { code: 'OHD', color: '#999999' },
  NST: { code: 'NST', color: '#0370C3' },
  PHD: { code: 'PHD', color: '#FF0000' },
};

const List = ({ getCemexTrackingOrders }) => {
  const { project } = useOutletContext();
  const intl = useIntl();
  const navigate = useNavigate();
  const [date, setDate] = useState(dayjs());
  if (
    !project.concrete_providers.some((cp) => cp.provider === Providers.CEMEX)
  ) {
    return <Navigate to="/" />;
  }
  return (
    <>
      <div className={`row ${actionsWrapper}`}>
        <div
          className="col-sm-12"
          style={{ display: 'flex', justifyContent: 'flex-end' }}
        >
          <AntdDatePicker
            value={date}
            onChange={setDate}
            style={{ width: '200px', backgroundColor: '#fff' }}
            showTime={false}
            format="DD/MM/YYYY"
          />
          <AccionaButton
            id="viewMap"
            type="white"
            onClick={() => {
              navigate('../map');
            }}
            msg={intl.formatMessage({ id: 'button.map' })}
            classIcon="icon far fa-map"
          />
          <AccionaButton
            id="viewMap"
            type="white"
            onClick={() => {
              getCemexTrackingOrders({
                filters: {
                  date: date.format('YYYY-MM-DD'),
                  project: project.id_project,
                },
              });
            }}
            msg={intl.formatMessage({ id: 'button.update.end' })}
            classIcon="icon fas fa-sync"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <AccionaTable
            title={intl.formatMessage({ id: 'cemexTracking.list.title' })}
            isSelectionDisabled={(preRegister) => preRegister.prm_data}
            columns={COLUMNS_HEADERS}
            initialFilters={{
              date: date.format('YYYY-MM-DD'),
              project: project.id_project,
            }}
            getItems={getCemexTrackingOrders}
            entity="cemexTracking"
            actions={undefined}
            expandable={{
              rowExpandable: (order) => {
                return order.rawObject.orderStatusGroupCode !== 'WCL';
              },
              expandedRowRender: (row) => (
                <tr>
                  <td></td>
                  <td colSpan={6}>
                    <div className={expanded}>
                      <p>
                        {intl.formatMessage({
                          id: 'cemexTracking.list.expanded.title',
                        })}
                      </p>
                      <table cellPadding={10} width="100%">
                        <thead>
                          <tr>
                            <th>
                              {intl.formatMessage({
                                id: 'cemexTracking.list.expanded.status',
                              })}
                            </th>
                            <th>
                              {intl.formatMessage({
                                id: 'cemexTracking.list.expanded.load',
                              })}
                            </th>
                            <th>
                              {intl.formatMessage({
                                id: 'cemexTracking.list.expanded.docketNumber',
                              })}
                            </th>
                            <th>
                              {intl.formatMessage({
                                id: 'cemexTracking.list.expanded.truck',
                              })}
                            </th>
                            <th>
                              {intl.formatMessage({
                                id: 'cemexTracking.list.expanded.product',
                              })}
                            </th>
                            <th>
                              {intl.formatMessage({
                                id: 'cemexTracking.list.expanded.quantity',
                              })}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {row.tickets.map((ticket) => (
                            <tr key={ticket.ticketId}>
                              <td align="center">
                                <Tag
                                  color={
                                    STATUS_DICTIONARY[ticket.ticketStatusCode]
                                      .color
                                  }
                                >
                                  {intl
                                    .formatMessage({
                                      id:
                                        'cemex.status.' +
                                        ticket.ticketStatusCode,
                                    })
                                    .toLocaleUpperCase()}
                                </Tag>
                              </td>
                              <td align="center">{ticket.loadNumber}</td>
                              <td align="center">{ticket.ticketSourceCode}</td>
                              <td align="center">{ticket.truckPlate}</td>
                              <td align="center">{ticket.productDesc}</td>
                              <td align="center">
                                {ticket.totalDeliveredQuantity}{' '}
                                {ticket.unitOfMeasure || 'M3'}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              ),
            }}
            dataParseFunction={(orders) =>
              orders.map((order) => ({
                ...order,
                rawObject: order,
                orderStatusGroupCode: (
                  <Tag
                    color={STATUS_DICTIONARY[order.orderStatusGroupCode].color}
                  >
                    {intl
                      .formatMessage({
                        id: 'cemex.status.' + order.orderStatusGroupCode,
                      })
                      .toLocaleUpperCase()}
                  </Tag>
                ),
                product: order.tickets?.[0]?.productDesc,
                loads:
                  (order.totalDeliveries || 0) + '/' + (order.totalLoads || 0),
                programedDateTime: dayjs(order.programedDateTime).format(
                  'DD/MM/YYYY',
                ),
                volume: (
                  <VolumeStatus
                    total={order.totalQuantity || 0}
                    progress={order.deliveredQuantity || 0}
                    unit={order.unitOfMeasure || 'M3'}
                  />
                ),
              }))
            }
          />
        </div>
      </div>
    </>
  );
};

List.propTypes = {
  getCemexTrackingOrders: PropTypes.func.isRequired,
};

export { STATUS_DICTIONARY };
export default connect(() => ({}), {
  getCemexTrackingOrders: actions.getCemexTrackingOrders,
})(List);
